import { render, staticRenderFns } from "./sidebar-fvc.vue?vue&type=template&id=98953c40&scoped=true"
import script from "./sidebar-fvc.vue?vue&type=script&lang=js"
export * from "./sidebar-fvc.vue?vue&type=script&lang=js"
import style0 from "./sidebar-fvc.vue?vue&type=style&index=0&id=98953c40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98953c40",
  null
  
)

export default component.exports